import { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";
import { useContext } from "react";
import { AuthContext } from "../contexts/AuthContext";
import toast from 'react-hot-toast';
import axiosInstance from "../utils/axiosInstance";

const MeetingScheduler = ({ receiverId, onClose }) => {
  const { userId, token } = useContext(AuthContext);
  const [dateTime, setDateTime] = useState(new Date());
  const [link, setLink] = useState("");

  const scheduleMeeting = async () => {
    try {
      await axiosInstance.post(
        `${process.env.REACT_APP_API_BASE}/api/meetings`,
        {
          organizer: userId,
          participant: receiverId,
          time: dateTime,
          link: link.trim(),
        },
        {
          headers: { Authorization: token },
        }
      );
      toast.success("Meeting scheduled!");

      if (onClose) onClose(); // ✅ close scheduler UI
    } catch (err) {
      toast.error("❌ Failed to schedule meeting");
    }
  };

  return (
    <div className="p-4 border rounded bg-white shadow-md space-y-3">
      <h3 className="font-bold text-lg">Schedule a Meeting</h3>

      <label className="block text-sm font-medium text-gray-700">Pick Date & Time:</label>
      <DatePicker
        selected={dateTime}
        onChange={(date) => setDateTime(date)}
        showTimeSelect
        timeFormat="HH:mm"
        timeIntervals={15}
        dateFormat="Pp"
        className="border px-2 py-1 rounded w-full"
      />

      <label className="block text-sm font-medium text-gray-700">Optional Meeting Link:</label>
      <input
        type="text"
        value={link}
        onChange={(e) => setLink(e.target.value)}
        placeholder="https://meet.google.com/..."
        className="border px-2 py-1 rounded w-full"
      />

      <button
        onClick={scheduleMeeting}
        className="bg-indigo-600 text-white px-4 py-2 rounded hover:bg-indigo-500"
      >
        Schedule
      </button>
    </div>
  );
};

export default MeetingScheduler;
